<p-accordion>
  <p-accordionTab header="{{ 'HOME.HEAD_TO_HEAD' | translate }}">
    <p class="px-2 mb-0 pt-2">{{ "HOME.HEAD_TO_HEAD_DESC" | translate }}</p>
    <hr />
    <div class="head2head_more text-right px-2 pb-2">
      <span>{{ "HOME.MORE" | translate }}</span> &nbsp;
      <i class="fa fa-arrow-right"></i>
    </div>
  </p-accordionTab>
</p-accordion>
